import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AppTokenHandler, HTTPStatus } from 'src/app/Global-Services/app-token-handler';
import { catchError, finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/Global-Services/common.service';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
    public pendingRequests: any = 0;
    public azure_access_token_key = 'AzureAccessToken';
    constructor(private appToken: AppTokenHandler, private status: HTTPStatus, private route: Router, private gservice : CommonService ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.pendingRequests++;
        this.status.setHttpStatus(true);
         const access_token_value = this.appToken.getSessionToken();
         if(req.url.startsWith('https://login.microsoftonline.com')){
          return next.handle(req);
        }
        else if (access_token_value != null) {
        const authReq = req.clone({
          headers: new HttpHeaders({
            'access_token_value': this.appToken.getSessionToken(),
            'AzureAccessToken': this.appToken.getAzureTokenFromLocalStorage(),
        }),
            withCredentials: true
        });
        return next.handle(authReq).pipe(catchError((err: HttpErrorResponse) => {
           if (err.status === 401) {
                this.gservice.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
                });
                this.route.navigate(['/error/1']);
                return;
            }
            if  (err.status === 417) {
                this.gservice.GetRestItems('Master/LogError?httpException=' + err).subscribe(data => {
                });
                this.route.navigate(['/error/3']);
                return;
                }
                return throwError(err.statusText);
        }), finalize(() => {
            this.pendingRequests--;
            if (this.pendingRequests <= 0) {
                this.status.setHttpStatus(false);
            }
        })
        );
    }
    return next.handle(req);
  }

}
